import styled from "styled-components";
export const AirplaneBookingWrapper = styled.div`
  background-color: #fff;
  width: 100%;
`;
